<!-- Tech Geek Hero Section -->
<div class="annual-hero-bg">
  <section class="annual-hero-section container">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5 hero-content-col">
          <h1 class="banner-heading-one">Tech Geek</h1>
          <nav aria-label="breadcrumb" class="breadcrumb-nav">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a (click)="navigateToHome()">Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Tech Geek</li>
            </ol>
          </nav>
        </div>
        <div class="col-lg-7 hero-image-col">
          <img src="../../../../assets/resources/techgeek/techgeek-bannerimage.png" alt="Tech Geek Illustration"
            class="hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- Tech Geek List Section -->
<div class="techgeeks-list-section">
  <div class="container">
    <h2 class="section-title">Explore Our TechGeeks</h2>

    <div class="row g-4">
      <div class="col-lg-4 col-md-6" *ngFor="let tg of techgeekcards">
        <div class="techgeek-card h-100" (click)="tg.clickMethod()">
          <div class="card-image-wrapper">
            <img [src]="tg.imagePath" [alt]="tg.month" class="card-image">
          </div>
          <div class="card-content">
            <div class="info-wrapper">
              <h6 class="card-title">{{ tg.month }}</h6>
              <div class="card-meta">
                <i class="ri-calendar-line"></i> Posted on {{ tg.postedOn }}
              </div>
            </div>
            <div class="arrow-icon-wrapper">
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>